import { useSelector } from 'react-redux'
import { getHitsResults, getSortIndice } from '../selectors/algolia'
import {
  getCollectionData,
  getHasValidPermissions,
  getIsCollectionPrivate,
} from '../selectors/collection'
import { getAdminUrlLinks, getOwnerId, getUrlPathString } from '../selectors/url'
import { collectionTransformer } from '../helpers/collectionTransformer'
import { collectionArtworksTransformer } from '../helpers/collectionArtworksTransformer'
import { isSessionSet } from 'selectors/user/session'

const useCollectionLayout = () => {
  const hitsResults = useSelector(getHitsResults)
  const artworks = collectionArtworksTransformer(hitsResults)
  const collectionMetadata = useSelector(getCollectionData)
  const collectionData = collectionTransformer(collectionMetadata)
  const collectionOwnerId = useSelector(getOwnerId)
  const algoliaIndice = useSelector(getSortIndice)
  const adminUrlLinks = useSelector(getAdminUrlLinks)
  const isCollectionPrivate = useSelector(getIsCollectionPrivate)
  const hasValidPermissions = useSelector(getHasValidPermissions)
  const urlPathString = useSelector(getUrlPathString)
  const isSet = useSelector(isSessionSet)

  return {
    artworks,
    collectionData,
    collectionOwnerId,
    algoliaIndice,
    adminUrlLinks,
    isCollectionPrivate,
    hasValidPermissions,
    urlPathString,
    isSet,
  }
}

export default useCollectionLayout
